@if (isFromDashboard) {
  <!-- DS template -->
  <div>
    <ds-textfield class="no-subscript" placeholder="{{appStrings.quotes_search}}" (click)="openAdvancedFilteringDialog()"
      end_adornment_type="icon" end_adornment_value_icon="search" [control]="displayedSearchValue" id="quoteSearchField"
      [ngClass]="isMobile ? 'fill-width' : ''">
    </ds-textfield>
    @if (currentSearchText) {
      <div class="showing-text" id="showingText">
        <span id="showResults">{{appStrings.accounts_showingResultsFor}}
          @if (currentSearchText) {
            <span>"{{currentSearchText}}".</span>
          }
        </span>
        <span id="clearAllFilters" class="clickable" (click)="clearFilters()">{{appStrings.accounts_clearFilters}}</span>
      </div>
    }
  </div>
} @else {
  <!-- Legacy template (desktop) -->
  <div *appIsDesktop>
    <div id="searchForm" class="filter-form">
      <div id="searchContainer" class="search-container">
        <mat-form-field id="searchField" appearance="outline" class="margin-right quote-search last-quote-search"
          (click)="openAdvancedFilteringDialog()">
          <mat-label>{{appStrings.quotes_search}}</mat-label>
          <input autocomplete="off" matInput id="quoteSearchFields" readonly
            [formControl]="displayedSearchValue" class="displayed-search-values" #searchInput>
          <span id="iconSearch" matSuffix class="crm-industrial-font icon-search"></span>
        </mat-form-field>
      </div>
    </div>
    @if (currentSearchText) {
      <div class="showing-text">
        <span id="showResults">{{appStrings.accounts_showingResultsFor}}
          @if (currentSearchText) {
            <span>"{{currentSearchText}}".</span>
          }
        </span>
        <span id="clearAllFilters" class="clickable" (click)="clearFilters()">{{appStrings.accounts_clearFilters}}</span>
      </div>
    }
  </div>

  <!-- Legacy template (mobile) -->
  <div *appIsMobile class="mobile">
    <div id="searchForm" class="filter-form">
      <div id="searchContainer" class="search-container">
        <mat-form-field id="searchField" appearance="outline" class="quote-search last-quote-search no-subscript"
          (click)="openAdvancedFilteringDialog()">
          <mat-label>{{appStrings.quotes_search}}</mat-label>
          <input autocomplete="off" matInput id="quoteSearchFields" readonly
            [formControl]="displayedSearchValue" class="displayed-search-values" #searchInput>
          <span id="iconSearch" matSuffix class="crm-industrial-font icon-search"></span>
        </mat-form-field>
      </div>
    </div>
    @if (currentSearchText) {
      <div class="showing-text">
        <span id="showResults">{{appStrings.accounts_showingResultsFor}}
          @if (currentSearchText) {
            <span>"{{currentSearchText}}".</span>
          }
        </span>
        <span id="clearAllFilters" class="clickable" (click)="clearFilters()">{{appStrings.accounts_clearFilters}}</span>
      </div>
    }
  </div>
}